"use client";

interface ShiftStatusConfirmModalProps {
  mode: "activate" | "deactivate";
  shiftName: string;
  /** Số lượt gán ca từ ngày mai trở đi sẽ bị xoá — có giá trị khi BE yêu cầu xác nhận lần 2. */
  assignmentCount?: number;
  onCancel: () => void;
  onConfirm: () => void;
  isProcessing?: boolean;
}

const ShiftStatusConfirmModal: React.FC<ShiftStatusConfirmModalProps> = ({
  mode,
  shiftName,
  assignmentCount,
  onCancel,
  onConfirm,
  isProcessing = false,
}) => {
  const isDeactivate = mode === "deactivate";
  const needsSecondConfirm = isDeactivate && !!assignmentCount;
  const title = isDeactivate ? "Tạm ngưng ca làm việc" : "Kích hoạt ca làm việc";
  const description = isDeactivate
    ? `Bạn có chắc muốn tạm ngưng ca làm việc "${shiftName}"?`
    : `Bạn có chắc muốn kích hoạt lại ca làm việc "${shiftName}"?`;
  const confirmLabel = needsSecondConfirm ? "Xoá lượt gán và tạm ngưng" : isDeactivate ? "Tạm ngưng" : "Kích hoạt";

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/50 px-4">
      <div className="w-full max-w-md rounded-2xl bg-white p-6 shadow-2xl">
        <h3 className="text-lg font-semibold">{title}</h3>
        <p className="mt-3 text-sm text-slate-600">{description}</p>
        {needsSecondConfirm && (
          <p className="mt-3 rounded-lg border border-amber-200 bg-amber-50 px-3 py-2 text-sm text-amber-800">
            Ca này đang được gán cho nhân viên trong các ngày sắp tới ({assignmentCount} lượt gán). Nếu tiếp tục,
            các lượt gán từ ngày mai trở đi sẽ bị xoá và không thể khôi phục.
          </p>
        )}

        <div className="mt-6 flex justify-end gap-3">
          <button onClick={onCancel} disabled={isProcessing} className="rounded-full border px-4 py-2 text-sm font-medium text-slate-600 hover:bg-slate-100">Hủy</button>
          <button onClick={onConfirm} disabled={isProcessing} className={`rounded-full px-4 py-2 text-sm font-medium text-white ${isDeactivate ? "bg-amber-500 hover:bg-amber-600" : "bg-emerald-600 hover:bg-emerald-700"} disabled:opacity-60`}>
            {isProcessing ? "Đang xử lý..." : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ShiftStatusConfirmModal;